{
  "network": "Sin conexión con el servidor. Revisa tu internet.",
  "server_500": "Algo salió mal en el servidor. Inténtalo de nuevo en un momento.",
  "forbidden": "No tienes permiso para hacer esto.",
  "not_found": "No se encontró el recurso.",
  "validation": "Datos inválidos.",
  "rate_limit": "Demasiadas solicitudes. Espera un momento.",
  "generic": "No se pudo completar la acción.",
  "boundary_title": "Algo salió mal",
  "boundary_message": "Esta sección encontró un error inesperado. Puedes recargar la página o volver al inicio.",
  "boundary_reload": "Recargar página",
  "boundary_home": "Ir al inicio",
  "global_handler": "Algo no funcionó bien. Si persiste, recarga la página.",
  "google_sign_in_browser_only": "Google Sign-In requiere un navegador.",
  "google_sign_in_load_failed": "No se pudo cargar Google Sign-In.",
  "google_client_id_missing": "VITE_GOOGLE_CLIENT_ID no está configurado.",
  "google_no_credential": "Google no devolvió credencial.",
  "not_found_page": {
    "title": "Página no encontrada",
    "body": "La página que buscas no existe o cambió de lugar.",
    "home": "Ir al inicio",
    "app": "Ir a mi cuenta"
  }
}
